import React from 'react';
import './Toast.css';

const Toast = ({ toast }) => {
  if (!toast.show) return null;

  return (
    <div className={`custom-toast ${toast?.type}`}>
      {toast?.message}
    </div>
  );
};

export default Toast; 